import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#181818] text-neutral-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex flex-col leading-none mb-3">
            <span className="font-extrabold text-2xl text-[#C91F1F]" style={{ fontFamily: "Outfit" }}>NALIN</span>
            <span className="text-[10px] tracking-[0.25em] text-[#D4A928] font-bold">ATACADO & VAREJO</span>
          </div>
          <p className="text-sm text-neutral-400 leading-relaxed">
            Moda para todos os estilos, com preço, variedade e atendimento próximo.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Institucional</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/institucional/sobre" className="hover:text-white">Sobre a Nalin</Link></li>
            <li><Link to="/institucional/loja" className="hover:text-white">Nossa loja</Link></li>
            <li><Link to="/institucional/contato" className="hover:text-white">Contato</Link></li>
            <li><Link to="/institucional/faq" className="hover:text-white">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Políticas</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/institucional/privacidade" className="hover:text-white">Privacidade</Link></li>
            <li><Link to="/institucional/termos" className="hover:text-white">Termos de uso</Link></li>
            <li><Link to="/institucional/trocas" className="hover:text-white">Trocas e devoluções</Link></li>
            <li><Link to="/institucional/retirada" className="hover:text-white">Retirada</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Contato</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0" /> Rua Dr. Siqueira, nº 269, Magé - RJ</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> +55 21 98495-3716</li>
            <li className="flex items-center gap-2"><Instagram className="h-4 w-4" /> <a href="https://instagram.com/nalinatacado" target="_blank" rel="noreferrer" className="hover:text-white">@nalinatacado</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-neutral-800 py-4 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} Nalin Atacado & Varejo. Todos os direitos reservados.
      </div>
    </footer>
  );
}
